import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'dropdown-item',
    templateUrl: './dropdown-item.component.html',
    styleUrls: ['./dropdown-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DropdownItemComponent {

  @Input() accessVisibilityIn;
  @Input() accessDisableIn;
  @Input() routerLink;
  @Input() iconClass;
  @Input() target;
  @Input() href: string;
  @Input() buttonClass: string;
}
